module.exports = __webpack_public_path__ + "static/media/Zscaler-Logo-Color-RGB.a087a82a.svg";